<template>
  <div>
    <b>{{label}}: </b>
    <span>
      <span v-html="value"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: "rdkm-static-text",
  props: ["cols", "value", "label"]
};
</script>